var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_7619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0026 10V12H16.0026V13.3333H14.0026V15.3333H12.6693V13.3333H10.6693V12H12.6693V10H14.0026ZM14.0081 2C14.3733 2 14.6693 2.29663 14.6693 2.66227V8.66667H13.3359V3.33333H2.66927V12.666L9.33594 6L11.3359 8V9.886L9.33594 7.8856L4.55394 12.6667H9.33594V14H1.99714C1.63197 14 1.33594 13.7034 1.33594 13.3377V2.66227C1.33594 2.29651 1.63948 2 1.99714 2H14.0081ZM5.33594 4.66667C6.07232 4.66667 6.66927 5.26362 6.66927 6C6.66927 6.7364 6.07232 7.33333 5.33594 7.33333C4.59956 7.33333 4.0026 6.7364 4.0026 6C4.0026 5.26362 4.59956 4.66667 5.33594 4.66667Z",
    fill: "#128C7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_7619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/Media.f3d743613a46ecd65b033e9472519d0b.svg";
export { ForwardRef as ReactComponent };